export const CART_ENDPOINT = '/api/v1/cart'
export const CART_ENDPOINT_V3 = '/api/v3/carts'
export const CART_UNIQUE_PRODUCTS_COUNT = '/unique-products-count'
export const CART_STORES_ENDPOINT = '/shipment-modalities'
export const CART_KAZAPLAN = '/addkazaplan'

export const ENDPOINT_SHIPMENT = '/api/v1/shipments'
